import axios from 'axios'

import { resolveRequest } from 'utility-tools/module/requests'
import { requestIpAddress, TRequestGetGeoLocation } from 'utility-tools/module/location'
import { getIsFiscalLocationLegalByGeoLocationClientSide } from 'nexchange-service/module/auth'

import config from '@/config'

const { NEXT_API_URL } = config

const requestGeoLocationNextApi: TRequestGetGeoLocation = async ipAddress => {
    let ipInternal = ipAddress;
    if (!ipInternal) {
        const {
            data: { ip }
        } = await requestIpAddress()
        ipInternal = ip;
    }

    return resolveRequest(axios.get(`${NEXT_API_URL}/geo-location?ip=${ipInternal}`))
}

const requestGetIsFiscalLocationLegalByGeoLocation = async () =>
    // !!! USE IN CLIENT SIDE !!!
    getIsFiscalLocationLegalByGeoLocationClientSide(requestGeoLocationNextApi)

export { requestGetIsFiscalLocationLegalByGeoLocation, requestGeoLocationNextApi }
